const { cos, PI } = Math;

const easeInOut = (x) => -(cos(PI * x) - 1) / 2;

export default easeInOut;
